<script>
	// Stores
	import MeetingStore from '@/Stores/Racing/MeetingStore.js';
	// Components
	import Switch from '@/Components/Switch.svelte';
	// Services
	import { notify } from '@/Services/Notify.js';

	export let meeting;

	let boostableChecked = meeting && meeting.boostable;

	function updateBoostable() {
		MeetingStore.updateMeetingBoostable(meeting.id, boostableChecked)
			.then(() => {
				notify({
					type: 'success',
					title: `${meeting.name}`,
					message: `Boost Up for Meeting updated to ${boostableChecked ? 'On' : 'Off'}`,
					timeout: 3
				});
			})
			.catch(() => {
				boostableChecked = !boostableChecked;
				notify({
					type: 'danger',
					title: `${meeting.name}`,
					message: 'Failed to update Boost Up',
					timeout: 3
				});
			});
	}
</script>

<div class="ml-4 mr-2 font-semibold uppercase">Boost Up</div>
<Switch on:change={updateBoostable} name={`boost-meeting-${meeting.id}`} bind:checked={boostableChecked} small={true} />
